module.exports = __webpack_public_path__ + "static/media/locationDark.42f4a3d1.svg";